import React, { useState, useEffect, memo, useContext } from "react";
import { Link } from "react-router-dom";
import { BuilderDataContext } from "../../BuilderContext";
import { useDashboardState } from "components/DashboardContext";
import { getNextLevel } from "../../../utils/builder/IModelsTree";
import { searchLevel, searchTreeFun, findFoldersTreeObj } from "utils/helpers";
import { CSSTransition } from "react-transition-group";
import classNames from "classnames";
import "./ProjectNavItem.scss";

import ProjectNavList from "components/uiComponents/ProjectNavList";

import { ReactComponent as ArrowIcon } from "static/icons/arrow.svg";
import hubImage from 'static/images/fileTypes/hub.png';

const ProjectNavItem = memo(
  ({
    item: {
      children,
      id,
      text,
      type,
      stat, // do it needed?
      pictureUrl,
      lastUpdate,
      size,
      updatedBy,
    },
    treeAction,
    searchValue,
    level,
  }) => {
    const {
      foldersTree,
      activeFolder,
      setFoldersTree,
      setActiveFolder,
    } = useDashboardState();

    const { builderData, setBuilderData } = useContext(BuilderDataContext);
    const [list, setList] = useState(null);
    const [active, setActive] = useState("close");

    const openFolder = () => {
      setActive((prevState) => {
        if (prevState === "active") {
          treeAction(id, [], false, level);
          return "close";
        } else if (list) {
          treeAction(id, list, true, level);
          return "active";
        } else return "load";
      });
    };

    const handleClick = () => {
      openFolder();
      setActiveFolder(id);

      if (!list) {
        getNextLevel(id)
          .then(res => {
            treeAction(id, res, true, level);
            return res;
          })
          .then(res => {
            const requestedObj = findFoldersTreeObj(id, foldersTree);

            if (requestedObj) {
              if (!requestedObj?.childrenArr?.length) {
                requestedObj.childrenArr = res;
              }
            }

            setFoldersTree(foldersTree);
            setList(res);
          })
          .then(() => setActive("active"));
      }
    };

    const handleClick2 = () => {
      setBuilderData({
        ...builderData,
        project: {
          id,
          type,
          children,
          text,
        },
      });
    };

    useEffect(() => {
      let tree = JSON.parse(localStorage.getItem("tree"));
      if (tree) {
        if (searchTreeFun(tree, id)) {
          setActive("load");
          getNextLevel(id)
            .then((res) => {
              const requestedObj = findFoldersTreeObj(id, foldersTree);

              if (requestedObj) {
                if (!requestedObj?.childrenArr?.length) {
                  requestedObj.childrenArr = res;
                }
              }

              setFoldersTree(foldersTree);
              setList(res);
            })
            .then(() => setActive("active"));
        }
      }
    }, []);

    useEffect(() => {
      const searchFunction = async () => {
        setActive("load");
        
        const { list, condition } = await searchLevel(
          searchValue,
          getNextLevel,
          id
        );

        setActive(condition ? "active" : "close");
        setList(list);
        treeAction(id, list, condition, level);
      };
      if (level === 1 && searchValue !== null) {
        searchFunction();
      }
    }, [searchValue]);

    if (children) {
      return (
        <div className={`project-nav-item ${stat ? "searched_folder" : ""}`}>
          <div className={`project-nav-item__title ${active}`} onClick={handleClick}>
            <div
              style={{ backgroundImage: `url('${hubImage}')` }}
              className="project-nav-item__title_avatar"
            />

            <h5
              className="project-nav-item__title_text"
            >
              {text}
            </h5>

            <ArrowIcon
              className={classNames({
                "project-nav-item__title_icon": true,
                "project-nav-item__title_icon--active": active === 'active',
              })}
            />
          </div>

          <CSSTransition
            in={active === "active" && !!list}
            timeout={100}
            unmountOnExit={true}
            classNames="list"
            appear
          >
            <ProjectNavList
              list={list}
              treeAction={treeAction}
              searchValue={searchValue}
              level={level + 1}
            />
          </CSSTransition>
        </div>
      );
    } else {
      return (
        <div className="folder-title single_folder">
          <Link to={`/project/${id}`} onClick={handleClick2}>
            {text}
          </Link>
        </div>
      );
    }
  }
);

export default ProjectNavItem;
